import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { Pencil } from "../../../../../styles/icons/pencil";
import type { CustomHeader } from "../../server/supabase-custom-email-header-service";

export const EditHeaderButton: FC<{
  customHeader: CustomHeader;
  onClick: () => void;
}> = ({ customHeader, onClick }) => {
  return (
    <GridActionsCellItem
      key="edit"
      icon={
        <Tooltip title={`Edit "${customHeader.display_name}"`} placement="right">
          <Pencil fontSize="small" />
        </Tooltip>
      }
      label={`Edit "${customHeader.display_name}"`}
      aria-label={`Edit "${customHeader.display_name}"`}
      onClick={onClick}
      showInMenu={false}
    />
  );
};
